import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

import {LocalStorageKey} from '../app-enums/local-storage-key';
import {EnvironmentHelper} from '../services/environment-helper';
import {Tab} from '../app-enums/tab';

@Injectable({providedIn: 'root'})
export class ViewLanguageService {

  constructor(private environmentHelper: EnvironmentHelper,
              private router: Router,
              private translateService: TranslateService) {
  }

  public initCurrentLanguage(): void {
    // en — резервный язык: en.json (источник Crowdin) — единственная всегда
    // полная локаль; ключи, ещё не долетевшие до текущей локали, берутся из
    // неё с интерполяцией. Fallback ngx-translate работает только при
    // defaultLang !== currentLang, поэтому язык портала сюда ставить нельзя.
    this.translateService.setDefaultLang('en');
    let language = this.get();
    this.translateService.use(language);
  }

  public get(): string {
    const storedLanguage = window.localStorage.getItem(LocalStorageKey.LANGUAGE);
    if (storedLanguage) {
      return storedLanguage;
    }

    const interfaceLanguage = this.getLanguageByInterface();
    this.set(interfaceLanguage);
    return interfaceLanguage;
  }

  public set(l: string): boolean {
    window.localStorage.setItem(LocalStorageKey.LANGUAGE, l);
    if (l !== this.translateService.currentLang) {
      this.translateService.use(l);
      return true;
    }
    return false;
  }

  private getLanguageByInterface(): string {
    if (this.router.url.includes(Tab.PUBLIC)) {
      const userGlobalLanguage = window.navigator.language.slice(0, 2);
      this.set(userGlobalLanguage);
      return userGlobalLanguage;
    }
    return this.environmentHelper.defaultLanguage;
  }
}
